import { create } from 'zustand';

export const useSlotStore = create((set, get) => ({
    submittedSlots: [],

    // Accepts an array of slots and merges them uniquely by session_id
    // addOrUpdateSlot: (newSlots) => {
    //     const current = get().submittedSlots;

    //     // Get all session_ids in newSlots
    //     const newSessionIds = newSlots.map(s => s.session_id);

    //     // Filter out old slots that match any of the incoming session_ids
    //     const filtered = current.filter(
    //         slot => !newSessionIds.includes(slot.session_id)
    //     );

    //     // Add the new slots
    //     const updated = [...filtered, ...newSlots];

    //     set({ submittedSlots: updated });
    // },

    addOrUpdateSlot: (newSlots) => {
        // Just replace the whole array — no merging
        set({ submittedSlots: [...newSlots] });
    },



    // Remove slot by session_id
    removeSlot: (sessionId) => {
        const current = get().submittedSlots;
        set({ submittedSlots: current.filter(s => s.session_id !== sessionId) });
    },
    clearAllSlots: () => {
        set({ submittedSlots: [] });
    },
}));
